import React, { useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import JoditEditor from "jodit-react";
import { ProtectAPi } from '../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../tools/BackButton';
import { Link } from 'react-router-dom';
import AdminQuickNav from '../AdminQuickNav';

const ServicesCreate = () => {

    const { http } = ProtectAPi();
    const editor = useRef(null);
    const navigate = useNavigate();

    const [loader, setLoader] = useState('off');
    const [layoutTitle, setLayoutTitle] = useState('');
    const [titleB, setTitleB] = useState(''); // Title in Bangla
    const [layoutSlug, setLayoutSlug] = useState('');
    const [layoutAltText, setLayoutAltText] = useState('');
    const [layoutDescription, setLayoutDescription] = useState(''); // English description
    const [descriptionB, setDescriptionB] = useState(''); // Description in Bangla
    const [layoutImage, setLayoutImage] = useState(null);
    const [imagePreview, setImagePreview] = useState('');

    // UPDATED: priority state (empty by default so no default value stored)
    const [priority, setPriority] = useState('');

    // NEW: Status field (default active)
    const [status, setStatus] = useState(1);

    // Error states (updated names)
    const [layoutImageError, setLayoutImageError] = useState('');
    const [titleError, setTitleError] = useState('');
    const [titleBError, setTitleBError] = useState(''); // error for title_b
    const [slugError, setSlugError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    const [descriptionBError, setDescriptionBError] = useState(''); // error for description_b
    const [layoutAltTextError, setLayoutAltTextError] = useState('');
    const [priorityError, setPriorityError] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'layoutTitle') setLayoutTitle(value);
        if (name === 'layoutSlug') setLayoutSlug(value);
        if (name === 'layoutAltText') setLayoutAltText(value);
        if (name === 'titleB') setTitleB(value);
    };

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        if (!selectedImage) return;
        setLayoutImage(selectedImage);
        const previewURL = URL.createObjectURL(selectedImage);
        setImagePreview(previewURL);
    };

    const handlePriorityChange = (e) => {
        // keep string so empty is allowed; backend will receive '' or number string
        setPriority(e.target.value);
    };

    const handleStatusChange = (e) => {
        const n = parseInt(e.target.value, 10);
        setStatus(Number.isNaN(n) ? 1 : n);
    };

    const submitForm = () => {
        setLoader('on');
        setLayoutImageError('');
        setTitleError('');
        setTitleBError('');
        setSlugError('');
        setDescriptionError('');
        setDescriptionBError('');
        setLayoutAltTextError('');
        setPriorityError('');

        const formData = new FormData();
        formData.append('title', layoutTitle);
        formData.append('title_b', titleB); // Bangla title
        formData.append('slug', layoutSlug);
        formData.append('alt_text', layoutAltText);
        formData.append('description', layoutDescription); // English
        formData.append('description_b', descriptionB); // Bangla
        if (layoutImage) formData.append('image', layoutImage);

        // Hidden Input (type) — send type = 2
        formData.append('type', 2);

        // Visible dropdown status (1 = active / 2 = inactive)
        formData.append('status', String(status));

        // append new priority field (send empty string if user left it empty)
        formData.append('priority', priority === '' ? '' : String(priority));

        http.post(`/store-services`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            if (res.data.status === '422') {
                const errors = res.data.error || {};
                setLoader('off');
                setLayoutImageError(errors.image ? errors.image[0] : '');
                setTitleError(errors.title ? errors.title[0] : '');
                setTitleBError(errors.title_b ? errors.title_b[0] : '');
                setSlugError(errors.slug ? errors.slug[0] : '');
                setDescriptionError(errors.description ? errors.description[0] : '');
                setDescriptionBError(errors.description_b ? errors.description_b[0] : '');
                setLayoutAltTextError(errors.alt_text ? errors.alt_text[0] : '');
                setPriorityError(errors.priority ? errors.priority[0] : '');
            } else {
                setLoader('off');
                // navigate then show success (keeps your previous behavior)
                navigate('/admin/landing-page/service?type=2');
                swal('Success', res.data.msg, 'success');
            }
        }).catch(error => {
            console.error('Error:', error);
            setLoader('off');
        });
    };

    const editorConfig = useMemo(() => ({
        readonly: false,
        placeholder: 'Start typing...',
        uploader: {
            insertImageAsBase64URI: true
        }
    }), []);

    return (
        <div className="main-content" style={{ marginTop: -20 }}>
            <section className="section">
                <div className="section-body">
                    <div className="row">
                        <div className="col-12">

                            <AdminQuickNav active="services" />

                            <div className="card card-primary">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between">
                                        <h5>Add Services</h5>
                                        <BackButton />
                                    </div>

                                    <div className="row mt-3">

                                        {/* Hidden input (type) */}
                                        <input type="hidden" name="type" value="2" />

                                        {/* Image Upload */}
                                        <div className="col-md-4">
                                            <label>Services Image</label>

                                            <div className="logo-box w-100">
                                                <div className="logo w-100">
                                                    <label htmlFor="layoutImage" className="w-100">
                                                        <div
                                                            className="image-box border border-dotted p-2 rounded w-100"
                                                            style={{
                                                                width: "100%",
                                                                height: "165px",
                                                                overflow: "hidden",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center"
                                                            }}
                                                        >
                                                            {imagePreview ? (
                                                                <img
                                                                    src={imagePreview}
                                                                    alt="Preview"
                                                                    className='rounded'
                                                                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                                />
                                                            ) : (
                                                                <img
                                                                    src="https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png"
                                                                    alt="Default"
                                                                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                                />
                                                            )}
                                                        </div>

                                                        <input
                                                            type="file"
                                                            id="layoutImage"
                                                            className="form-control d-none"
                                                            onChange={handleImageChange}
                                                        />

                                                        <span className="btn btn-primary mt-3 w-100">Upload Services Image</span>
                                                        <span className="text-danger d-block">{layoutImageError}</span>

                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Right column inputs */}
                                        <div className="col-md-8">
                                            <div className="row">
                                                {/* Title */}
                                                <div className="col-md-12">
                                                    <label>Title in English</label>
                                                    <input type="text" name="layoutTitle" value={layoutTitle} className="form-control" placeholder="Enter title in English" onChange={handleInputChange} />
                                                    <span className="text-danger">{titleError}</span>
                                                </div>

                                                {/* Title (Bangla) - new */}
                                                <div className="col-md-12 mt-3">
                                                    <label>Title In Bangla</label>
                                                    <input type="text" name="titleB" value={titleB} className="form-control" placeholder="Enter title in Bangla" onChange={handleInputChange} />
                                                    <span className="text-danger">{titleBError}</span>
                                                </div>

                                                {/* Slug (moved under title_b) */}
                                                <div className="col-md-12 mt-3">
                                                    <label>Slug (optional)</label>
                                                    <input type="text" name="layoutSlug" value={layoutSlug} className="form-control" placeholder="Enter slug" onChange={handleInputChange} />
                                                    <span className="text-danger">{slugError}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Alt Text */}
                                        <div className="col-md-4 mt-3">
                                            <label>Alt Text for Image</label>
                                            <input type="text" name="layoutAltText" value={layoutAltText} className="form-control" placeholder="Enter alt text" onChange={handleInputChange} />
                                            <span className="text-danger">{layoutAltTextError}</span>
                                        </div>

                                        {/* Status & Priority */}
                                        <div className="col-md-4 mt-3">
                                            <label>Status</label>
                                            <select
                                                className="form-control"
                                                value={status}
                                                onChange={handleStatusChange}
                                            >
                                                <option value={1}>Active</option>
                                                <option value={2}>Inactive</option>
                                            </select>
                                        </div>

                                        <div className="col-md-4 mt-3">
                                            <label>Priority (numeric)</label>
                                            <input
                                                type="number"
                                                name="priority"
                                                className="form-control"
                                                value={priority}
                                                onChange={handlePriorityChange}
                                                min={0}
                                                placeholder="Enter Priority"
                                            />
                                            <span className="text-danger">{priorityError}</span>
                                        </div>

                                        {/* Description (English) */}
                                        <div className="col-md-12 mt-5">
                                            <label>Description (English)</label>
                                            <JoditEditor
                                                ref={editor}
                                                value={layoutDescription}
                                                config={{ ...editorConfig, height: 300 }}
                                                tabIndex={1}
                                                onBlur={newContent => setLayoutDescription(newContent)}
                                                onChange={() => { }}
                                            />
                                            <span className="text-danger">{descriptionError}</span>
                                        </div>

                                        {/* Description (Bangla) - new */}
                                        <div className="col-md-12 mt-4">
                                            <label>Description (Bangla)</label>
                                            <JoditEditor
                                                ref={editor}
                                                value={descriptionB}
                                                config={{ ...editorConfig, height: 300 }}
                                                tabIndex={2}
                                                onBlur={newContent => setDescriptionB(newContent)}
                                                onChange={() => { }}
                                            />
                                            <span className="text-danger">{descriptionBError}</span>
                                        </div>

                                        <div className="col-md-12 text-center mt-5 mb-4">
                                            {loader === 'off' ? (
                                                <button type="submit" onClick={submitForm} className="btn btn-lg btn-primary">Create</button>
                                            ) : (
                                                <div className="spinner-border text-dark" role="status"></div>
                                            )}
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ServicesCreate;
